import { Component, computed } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectInProgressRequests } from "src/app/state/selectors/app.selectors";

@Component({
  selector: "app-loading-overlay",
  templateUrl: "./loading-overlay.component.html",
  styleUrls: ["./loading-overlay.component.scss"]
})
export class LoadingOverlayComponent {
  inProgressRequests = this.store.selectSignal(selectInProgressRequests);

  loading = computed(() => !!this.inProgressRequests().length);

  constructor(private store: Store) {}
}
